class DesignsExploreFilter extends HTMLElement {
  constructor() {
    super();
    this.addEventListener('change', this.onChange.bind(this));
  }

  onChange(event) {
    const input = event.target;
    if (!(input instanceof HTMLInputElement) || input.type !== 'checkbox') return;

    const url = new URL(window.location.href);
    const paramName = this.dataset.paramName;
    url.searchParams.delete(paramName);
    this.querySelectorAll('input[type=checkbox]:checked').forEach((el) => {
      url.searchParams.append(el.name, el.value);
    });
    url.searchParams.delete('page');

    DesignsExploreFilter.renderPage(url.searchParams.toString(), this.dataset.sectionId);
  }

  static renderPage(searchParams, sectionId) {
    const fetchUrl = `${window.location.pathname}?section_id=${sectionId}&${searchParams}`;

    DesignsExploreFilter.setLoading(true);

    fetch(fetchUrl)
      .then((response) => response.text())
      .then((html) => {
        const parsed = new DOMParser().parseFromString(html, 'text/html');

        const newGrid = parsed.getElementById('ProductGridContainer');
        const gridContainer = document.getElementById('ProductGridContainer');
        if (newGrid && gridContainer) {
          gridContainer.innerHTML = newGrid.innerHTML;
        }

        const newCount = parsed.getElementById('ProductCount');
        const countEl = document.getElementById('ProductCount');
        if (newCount && countEl) countEl.innerHTML = newCount.innerHTML;

        const newCountDesktop = parsed.getElementById('ProductCountDesktop');
        const countElDesktop = document.getElementById('ProductCountDesktop');
        if (newCountDesktop && countElDesktop) countElDesktop.innerHTML = newCountDesktop.innerHTML;

        ['.active-facets-mobile', '.active-facets-desktop'].forEach((selector) => {
          const src = parsed.querySelector(selector);
          const dst = document.querySelector(selector);
          if (src && dst) dst.innerHTML = src.innerHTML;
        });

        const newUrl = `${window.location.pathname}${searchParams ? '?' + searchParams : ''}`;
        history.pushState({ searchParams }, '', newUrl);
      })
      .catch((err) => {
        console.error('[designs-explore] fetch failed', err);
      })
      .finally(() => {
        DesignsExploreFilter.setLoading(false);
      });
  }

  static setLoading(isLoading) {
    document.querySelectorAll('designs-explore-filter').forEach((el) => {
      el.classList.toggle('is-loading', isLoading);
    });
    const collectionEl = document.querySelector('#ProductGridContainer .collection');
    if (collectionEl) collectionEl.classList.toggle('loading', isLoading);
  }
}

customElements.define('designs-explore-filter', DesignsExploreFilter);

window.addEventListener('popstate', () => {
  const el = document.querySelector('designs-explore-filter');
  if (!el) return;
  const searchParams = window.location.search.replace(/^\?/, '');
  DesignsExploreFilter.renderPage(searchParams, el.dataset.sectionId);
});

(function () {
  const MOBILE_BREAKPOINT = '(max-width: 749px)';
  let isPositioning = false;
  let currentIsMobile = null;
  const swiperInstances = new Set();

  // ===================== NEW =====================
  // Custom positions ONLY for this specific collection.
  // Numbers = "show the block AFTER this product number".
  // Desktop: 1st block after product 5, 2nd block after product 15
  // Mobile:  1st block after product 4, 2nd block after product 6
  const IKEA_HACK_HANDLE = 'ikea-hack-furniture-stickers';
  const IKEA_HACK_POSITIONS = {
    desktop: [5, 11],
    mobile: [4, 6],
  };

  function isIkeaHackCollection() {
    return window.location.href.indexOf(IKEA_HACK_HANDLE) !== -1;
  }
  // ================= END NEW =====================

  function positionFilters() {
    const grid = document.getElementById('product-grid');
    if (!grid) return;

    const isMobile = window.matchMedia(MOBILE_BREAKPOINT).matches;
    const step = isMobile ? 4 : 6;

    // ===================== NEW =====================
    // If we are on the ikea-hack collection, use the custom list above.
    // Otherwise this stays null and the normal "step" logic is used (unchanged).
    let customPositions = null;
    if (isIkeaHackCollection()) {
      customPositions = isMobile ? IKEA_HACK_POSITIONS.mobile : IKEA_HACK_POSITIONS.desktop;
    }
    // ================= END NEW =====================

    const filterItems = Array.from(grid.children)
      .filter((el) => el.classList && el.classList.contains('designs-explore-grid-item'))
      .sort((a, b) => Number(a.dataset.filterIndex || 0) - Number(b.dataset.filterIndex || 0));

    if (filterItems.length === 0) return;

    isPositioning = true;
    try {
      filterItems.forEach((item) => item.remove());

      const productItems = Array.from(grid.children).filter(
        (el) => el.classList && el.classList.contains('grid__item')
      );

      filterItems.forEach((item, i) => {
        // ===================== CHANGED =====================
        let targetIndex;
        if (customPositions && customPositions[i] != null) {
          // Custom collection: use the exact product number from the list.
          // We subtract 1 because the code counts products starting from 0.
          targetIndex = customPositions[i] - 1;
        } else {
          // Everything else (all other collections) works exactly as before.
          targetIndex = step * (i + 1) - 1;
        }
        // ================= END CHANGED =====================

        const anchor = productItems[targetIndex];
        if (anchor && anchor.nextSibling) {
          grid.insertBefore(item, anchor.nextSibling);
        } else {
          grid.appendChild(item);
        }
      });

      currentIsMobile = isMobile;
    } finally {
      isPositioning = false;
    }

    initSwipers();
  }

  function initSwipers() {
    if (typeof Swiper === 'undefined') return;

    swiperInstances.forEach((sw) => {
      if (!sw.el || !document.body.contains(sw.el)) {
        try { sw.destroy(true, true); } catch (_) {}
        swiperInstances.delete(sw);
      }
    });

    document.querySelectorAll('[data-designs-slider]').forEach((slider) => {
      if (slider._designsSwiper && swiperInstances.has(slider._designsSwiper)) {
        slider._designsSwiper.update();
        return;
      }
      const sw = new Swiper(slider, {
        slidesPerView: 'auto',
        spaceBetween: 16,
        breakpoints: {
          0: { spaceBetween: 16 },
          750: { spaceBetween: 56 },
        },
      });
      slider._designsSwiper = sw;
      swiperInstances.add(sw);
    });
  }

  function debounce(fn, delay) {
    let t;
    return function () {
      clearTimeout(t);
      t = setTimeout(fn, delay);
    };
  }

  const onResize = debounce(() => {
    const isMobile = window.matchMedia(MOBILE_BREAKPOINT).matches;
    if (isMobile !== currentIsMobile) positionFilters();
  }, 150);

  function observeGridReplacements() {
    const container = document.getElementById('ProductGridContainer');
    if (!container) return;
    const observer = new MutationObserver(() => {
      if (isPositioning) return;
      positionFilters();
    });
    observer.observe(container, { childList: true });
  }

  function init() {
    positionFilters();
    observeGridReplacements();
    window.addEventListener('resize', onResize);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();